import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EmbedParams } from "../../_objects/embedded-report";
import { ApiService } from "../base/api-base.service";
import { EmbeddedReportContractService } from "../interfaces/embedded-report-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { EmbeddedReportOfflineService } from "../offline/embedded-report-offline.service";
import { EmbeddedReportOnlineService } from "../online/embedded-report-online.service";

@Injectable({
  providedIn: "root"
})
export class EmbeddedReportService extends ApiService<EmbeddedReportContractService> implements EmbeddedReportContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: EmbeddedReportOfflineService,
    protected onlineService: EmbeddedReportOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  getEmbeddedReport(): Observable<EmbedParams> {
    return this.service.getEmbeddedReport();
  }
}
